import React, { useEffect } from "react";
import Navbar from "../pages/Navbar";
import Footer from "../pages/Footer";

const ComingSoon = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      {/* Navigation */}
      <Navbar />

      {/* Main Content Area */}
      <div className="flex-grow-1 d-flex align-items-center justify-content-center px-3 py-5">
        <div className="container text-center" style={{ maxWidth: "650px" }}>
          {/* SVG Illustration */}
          <div className="mb-4">
            <svg
              className="img-fluid"
              style={{ width: "250px", height: "250px" }}
              viewBox="0 0 400 400"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Background Circle */}
              <circle cx="200" cy="200" r="180" fill="#E0F2FE" opacity="0.3" />

              {/* Main Person Icon */}
              <circle cx="200" cy="140" r="45" fill="#8DCAE4" opacity="0.8" />
              <path
                d="M140 240 Q140 190 200 190 Q260 190 260 240 L260 300 Q260 310 250 310 L150 310 Q140 310 140 300 Z"
                fill="#8DCAE4"
                opacity="0.8"
              />

              {/* Tool Icons */}
              <g opacity="0.6">
                {/* Wrench */}
                <path
                  d="M100 120 L110 130 L100 140 L90 130 Z M110 130 L140 160"
                  stroke="#6B9BB0"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <circle cx="145" cy="165" r="8" fill="#6B9BB0" />

                {/* Hammer */}
                <rect
                  x="280"
                  y="150"
                  width="30"
                  height="10"
                  rx="2"
                  fill="#6B9BB0"
                />
                <rect
                  x="292"
                  y="160"
                  width="6"
                  height="60"
                  rx="2"
                  fill="#6B9BB0"
                />
              </g>

              {/* Clock Icon */}
              <circle
                cx="320"
                cy="240"
                r="35"
                stroke="#8DCAE4"
                strokeWidth="4"
                fill="white"
              />
              <path
                d="M320 215 L320 240 L335 240"
                stroke="#8DCAE4"
                strokeWidth="3"
                strokeLinecap="round"
              />

              {/* Calendar Icon */}
              <rect
                x="50"
                y="220"
                width="50"
                height="50"
                rx="5"
                fill="white"
                stroke="#8DCAE4"
                strokeWidth="3"
              />
              <line
                x1="60"
                y1="220"
                x2="60"
                y2="210"
                stroke="#8DCAE4"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="90"
                y1="220"
                x2="90"
                y2="210"
                stroke="#8DCAE4"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="55"
                y1="235"
                x2="95"
                y2="235"
                stroke="#8DCAE4"
                strokeWidth="2"
              />
            </svg>
          </div>

          {/* Text Content */}
          <h1 className="display-5 fw-bold text-dark mb-3">Coming Soon</h1>
          <p className="lead text-secondary mb-4 fs-4">
            Men's Services Are Under Development
          </p>

          {/* Info Card */}
          <div
            className="card border shadow-sm p-4 mb-4"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              backdropFilter: "blur(5px)",
              borderColor: "rgba(141, 202, 228, 0.3)",
            }}
          >
            <p className="fs-5 text-dark mb-3">
              We're currently working on bringing you specialized laser
              treatment services for men.
            </p>
            <p className="text-muted mb-0">
              Our team is preparing comprehensive packages tailored specifically
              for men's grooming and skin care needs. Check back soon!
            </p>
          </div>

          {/* Call to Action Buttons */}
          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mt-4">
            <button
              onClick={() => window.history.back()}
              className="btn btn-lg text-white px-4 py-2 shadow-sm"
              style={{
                background: "linear-gradient(to right, #8DCAE4, #6BB5D8)",
                border: "none",
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
